import { render } from "./SottoProgettoHead.vue?vue&type=template&id=4268316a&ts=true"
import script from "./SottoProgettoHead.vue?vue&type=script&lang=ts"
export * from "./SottoProgettoHead.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__